"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var BabyExercise = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BabyExercise, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(BabyExercise);

  function BabyExercise() {
    (0, _classCallCheck2["default"])(this, BabyExercise);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BabyExercise, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M12.0001524,8.36752622 C10.4475205,8.36752622 9.18896885,7.1659431 9.18896885,5.68376311 C9.18896885,4.20158312 10.4475205,3 12.0001524,3 C13.5527372,3 14.8113876,4.20158312 14.8113876,5.68376311 C14.8113876,7.1659431 13.5527372,8.36752622 12.0001524,8.36752622 Z M11.9955435,13.9776677 L9.02380125,13.9776677 L9.02380125,11.9292208 L6.75110078,14.1132072 C5.72435278,15.0933657 4.33265589,13.8365612 5.36109647,12.8546517 L9.12420923,9.25542449 C9.42943067,8.9661179 9.76347649,8.78204636 10.293593,8.78204636 L11.9955435,8.78204636 L11.9983652,8.78204636 L13.6679594,8.78204636 C14.1980759,8.78204636 14.5556412,8.96050596 14.8697512,9.25542449 L18.6710985,12.8899396 C19.6502056,13.824619 18.2209321,15.0933657 17.2818001,14.1490787 L14.9495133,11.9179969 L14.9495133,13.9776677 L11.9983652,13.9776677 L11.9955435,13.9776677 Z M14.9372386,15.0400299 C14.9372386,15.0400299 16.8369951,16.8554243 16.8390644,16.8573997 C17.4504479,17.4410412 17.292758,18.4671727 16.7224783,19.0227096 L14.0652646,21.6602752 C13.0397864,22.6392216 11.6717924,21.2852631 12.6634094,20.3385517 L14.3435852,18.7346152 L12.7038547,17.1722518 L14.9372386,15.0400299 Z M9.02431858,15.0400299 L11.2576977,17.1722518 L9.61797193,18.7346152 L11.2981431,20.3385517 C12.28976,21.2852631 10.921766,22.6392216 9.89628779,21.6602752 L7.23907885,19.0227096 C6.66879916,18.4671727 6.51110925,17.4410412 7.12249272,16.8573997 C7.12456202,16.8554243 9.02431858,15.0400299 9.02431858,15.0400299 Z"
      }));
    }
  }]);
  return BabyExercise;
}(_react["default"].PureComponent);

var _default = BabyExercise;
exports["default"] = _default;